import { Variant } from "../../types/types";

export const isVariantReducedToClear = (variant: Variant) => {
  return variant.messaging
    ? variant.messaging.some((message) =>
        /reduced to clear/i.test(message.title),
      )
    : false;
};
